import { render, staticRenderFns } from "./TicketsFAQGroupItem.vue?vue&type=template&id=b176147a&"
import script from "./TicketsFAQGroupItem.vue?vue&type=script&lang=js&"
export * from "./TicketsFAQGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports